import { useCallback, useState, useEffect } from "react";
import { Auth } from "routes/Auth";
import { Auth as AmplifyAuth } from "aws-amplify";
import { AuthContext } from "auth/AuthContext";
import { useAppDispatch } from "store/hooks";
import { showError } from "store/reducers/errorReducer";
import { ModalSpinner } from "components/ModalSpinner";

export const withAuthenticator = (WrappedComponent) => {
  const Component = () => {
    const dispatch = useAppDispatch();
    const [isAppLoaded, setIsAppLoaded] = useState(false);
    const [user, setUser] = useState();

    const signOut = useCallback(async () => {
      try {
        await AmplifyAuth.signOut();
        setUser(undefined);
      } catch (error) {
        dispatch(showError(error));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const signIn = useCallback((user) => setUser(user), []);

    useEffect(() => {
      const checkAuth = async () => {
        try {
          const currentUser = await AmplifyAuth.currentAuthenticatedUser();
          setUser(currentUser);
        } catch (error) {
        } finally {
          setIsAppLoaded(true);
        }
      };

      checkAuth();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isAppLoaded) {
      return <ModalSpinner open />;
    }

    return (
      <AuthContext.Provider
        // @ts-ignore
        value={{ user, signOut, signIn }}
      >
        {user ? (
          <WrappedComponent
            signOut={signOut}
            user={user}
          />
        ) : (
          <Auth />
        )}
      </AuthContext.Provider>
    );
  };

  return Component;
};
